import Location from '../models/location';

const isWithinBounds = (bounds: any, geolocation: any) => {
  if (!bounds) return false;

  const { nw, se } = bounds;
  const { lat, lng } = geolocation;

  const isLatitudeWithin = lat < nw.lat && lat > se.lat;
  const isLongitudeWithin = lng < se.lng && lng > nw.lng;

  return isLatitudeWithin && isLongitudeWithin;
};

const groupByCity = (locations: Location[]) => {
  const groupedLocations: { [x: string]: Location[] } = {};

  locations.forEach((location: Location) => {
    if (!groupedLocations[location.address.city]) {
      groupedLocations[location.address.city] = [];
    }

    groupedLocations[location.address.city].push(location);
  });

  return groupedLocations;
};

const groupByStateName = (locations: Location[]) => {
  const groupedLocations: { [x: string]: Location[] } = {};

  locations.forEach((location: Location) => {
    if (!groupedLocations[location.address.stateName]) {
      groupedLocations[location.address.stateName] = [];
    }

    groupedLocations[location.address.stateName].push(location);
  });

  const sortedStates = Object.keys(groupedLocations).sort();
  const sortedByCity: { [x: string]: Location[] } = {};

  sortedStates.forEach((state: string) => {
    sortedByCity[state] = groupedLocations[state].sort(
      (firstLoc: Location, secondLoc: Location) => {
        if (firstLoc.club > secondLoc.club) {
          return 1;
        }

        if (secondLoc.club > firstLoc.club) {
          return -1;
        }

        return 0;
      }
    );
  });

  return sortedByCity;
};

export { groupByCity, isWithinBounds, groupByStateName };
